import React from 'react';
import iconsSvg from '../../assets/img/svgLib/iconsSvg';
import PropTypes from 'prop-types';
import './CommerceOffer.scss';
import classNames from 'classnames';

const CommerceOffer = (props) => {
    const {idx, status, toggleOffer} = props;

    return status ?
        (<div className={'inOffer'} onClick={() => toggleOffer(idx, !status)}>{iconsSvg.done}

        </div>) :
        (<span className={classNames('needTooltip','offer')} onClick={() => toggleOffer(idx, !status)}>
          {iconsSvg.offer}
          </span>
        );
}

CommerceOffer.propTypes = {
    objectId: PropTypes.number,
    idx: PropTypes.number,
    status: PropTypes.bool,
    showModal: PropTypes.bool,
    toggleOffer: PropTypes.func,
}

export default CommerceOffer



// WEBPACK FOOTER //
// ./src/shared/CommerceOffer/CommerceOffer.js